import React, { useEffect, useState } from 'react';

import UserIcon from 'components/shared/UserIcon';
import { IReactionSummary, REACTION_TYPE } from 'constants/types';

import ReactionIcon from '../ReactionIcon';
import {
  ReactionItem,
  ReactionListContainer,
  StyledIcons,
  StyledModal,
  UserItem,
  UserList,
} from './styles';

interface ReactionResultsModalProps {
  isVisible: boolean;
  onClose: () => void;
  reactionSummary: IReactionSummary;
}

const ReactionResultsModal: React.FC<ReactionResultsModalProps> = ({
  isVisible,
  onClose,
  reactionSummary,
}) => {
  const [activeReaction, setActiveReaction] = useState<string>('All');

  useEffect(() => {
    if (reactionSummary?.reactions?.length > 0 && !activeReaction) {
      setActiveReaction('All');
    }
  }, [reactionSummary, activeReaction]);

  const handleReactionClick = (reactionId: string) => {
    setActiveReaction(reactionId);
  };

  const getActiveUsersWithReactions = () => {
    if (activeReaction === 'All') {
      return reactionSummary.reactions.flatMap((reaction) =>
        reaction.userDetails.map((user) => ({
          ...user,
          reactionType: reaction._id,
        })),
      );
    } else {
      const selectedReaction = reactionSummary.reactions.find(
        (reaction) => reaction._id === activeReaction,
      );
      return selectedReaction
        ? selectedReaction.userDetails.map((user) => ({
            ...user,
            reactionType: selectedReaction._id,
          }))
        : [];
    }
  };

  if (
    !reactionSummary ||
    !reactionSummary.reactions ||
    reactionSummary.reactions.length === 0
  ) {
    return null;
  }

  return (
    <StyledModal
      title="Reactions"
      visible={isVisible}
      onCancel={onClose}
      footer={null}
    >
      <ReactionListContainer>
        <ReactionItem
          key="All"
          isActive={activeReaction === 'All'}
          onClick={() => handleReactionClick('All')}
        >
          All: {reactionSummary.totalCount}
        </ReactionItem>

        {reactionSummary.reactions.map((reaction) => (
          <ReactionItem
            key={reaction._id}
            isActive={activeReaction === reaction._id}
            onClick={() => handleReactionClick(reaction._id)}
          >
            <ReactionIcon reactionType={reaction._id} />
            {reaction.count}
          </ReactionItem>
        ))}
      </ReactionListContainer>

      <UserList>
        {getActiveUsersWithReactions().map((user, index) => (
          <UserItem key={index}>
            <StyledIcons>
              <UserIcon
                firstName={user.firstName}
                lastName={user.lastName}
                userRole={user.role}
                width={'40'}
                height={'40'}
                marginRight={'-9'}
              />
              <ReactionIcon reactionType={user.reactionType} />
            </StyledIcons>
            <div>
              {user.firstName} {user.lastName}
            </div>
          </UserItem>
        ))}
      </UserList>
    </StyledModal>
  );
};

export default ReactionResultsModal;
